<div class="bulk-add-dialog">
  
  <div class="dialog-header">
    <h2 mat-dialog-title>
      <mat-icon>playlist_add</mat-icon>
      Añadir múltiples conceptos
    </h2>
    <button mat-icon-button [mat-dialog-close]="false" class="close-button" [disabled]="isCreating">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="alert alert-danger alert-dismissible fade show m-3" *ngIf="errorMessage" role="alert">
    <mat-icon>error</mat-icon>
    <span class="ms-2">{{ errorMessage }}</span>
    <button type="button" class="btn-close" (click)="clearError()"></button>
  </div>

  <mat-dialog-content>
    
    <div class="form-section" *ngIf="!isCreating && creationResults.length === 0">
      <h6 class="section-title">
        <mat-icon>store</mat-icon>
        Paso 1: Selecciona los conceptos
      </h6>

      <p class="description">
        Selecciona los conceptos de Handly que quieres habilitar para este centro de trabajo.
      </p>


      <div class="row mb-3">
        <div class="col-md-9">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Buscar concepto</mat-label>
            <input matInput [value]="searchTerm" (input)="searchTerm = $event.target.value; applyFilter()" placeholder="Buscar por nombre...">
            <mat-icon matPrefix>search</mat-icon>
          </mat-form-field>
        </div>
        <div class="col-md-3 d-flex align-items-center">
          <button mat-button (click)="toggleSelectAll()" [disabled]="filteredConcepts.length === 0">
            <mat-icon>{{ allSelected ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
            {{ allSelected ? 'Deseleccionar' : 'Seleccionar' }} todos
          </button>
        </div>
      </div>

      <div class="concepts-list">
        <div *ngFor="let concept of filteredConcepts; trackBy: trackByIndex" class="concept-item">
          <mat-checkbox 
            [checked]="isSelected(concept.id)"
            (change)="toggleSelection(concept.id)"
            [disabled]="isAlreadyAdded(concept.id)">
            
            <div class="concept-content">
              <div class="concept-main">
                <span class="concept-name">{{ concept.display }}</span>
                <span class="already-added-badge" *ngIf="isAlreadyAdded(concept.id)">Ya añadido</span>
              </div>
              <div class="concept-details">
                <span *ngIf="concept.metadata && concept.metadata.description" class="concept-description">{{ concept.metadata.description }}</span>
                <div class="concept-meta">
                  <span *ngIf="concept.metadata && concept.metadata.defaultDuration" class="meta-item">
                    <mat-icon>schedule</mat-icon>
                    {{ concept.metadata.defaultDuration }} min
                  </span>
                  <span *ngIf="concept.metadata && concept.metadata.price !== undefined && concept.metadata.price !== null" class="meta-item">
                    <mat-icon>attach_money</mat-icon>
                    {{ concept.metadata.price | number:'1.2-2' }}€
                  </span>
                </div>
              </div>
            </div>
          </mat-checkbox>
        </div>

        <div *ngIf="filteredConcepts.length === 0" class="filter-empty">
          <mat-icon>search</mat-icon>
          <p>No se encontraron conceptos{{ searchTerm ? ' con "' + searchTerm + '"' : '' }}</p>
        </div>
      </div>

      <div class="selected-concepts" *ngIf="selectedConceptIds.length > 0">
        <h6 class="mt-4 mb-2">Seleccionados ({{ selectedConceptIds.length }})</h6>
        <div class="selected-list">
          <mat-chip-listbox>
            <mat-chip-option *ngFor="let conceptId of selectedConceptIds; trackBy: trackByIndex">
              {{ getConceptName(conceptId) }}
              <button mat-icon-button class="chip-remove" (click)="removeSelected(conceptId)">
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip-option>
          </mat-chip-listbox>
        </div>
      </div>
    </div>

    <div class="form-section" *ngIf="selectedConceptIds.length > 0 && !isCreating && creationResults.length === 0">
      <h6 class="section-title">
        <mat-icon>settings</mat-icon>
        Paso 2: Valores predeterminados (opcional)
      </h6>

      <p class="description">
        Configura los valores que se aplicarán a todos los conceptos. Si un concepto tiene valores propios, se usarán esos.
      </p>

      <form [formGroup]="defaultsForm" class="defaults-form">
        <div class="row">
          <div class="col-md-6">
            <app-field 
              [control]="defaultsForm.get('durationMinutes')" 
              [config]="{ 
                label: 'Duración por defecto (minutos)', 
                type: 'number',
                required: true,
                helpText: 'Se usará si el concepto no tiene duración'
              }">
            </app-field>
          </div>

          <div class="col-md-6">
            <app-field
              [control]="defaultsForm.get('bufferBeforeMinutes')"
              [config]="{
                label: 'Margen antes (minutos)',
                type: 'number',
                helpText: 'Tiempo reservado antes del servicio'
              }">
            </app-field>
          </div>

          <div class="col-md-6">
            <app-field
              [control]="defaultsForm.get('bufferAfterMinutes')"
              [config]="{
                label: 'Margen después (minutos)',
                type: 'number',
                helpText: 'Tiempo reservado después del servicio'
              }">
            </app-field>
          </div>

          <div class="col-md-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Estado inicial</mat-label>
              <mat-select formControlName="statusMerchantConceptId">
                <mat-option *ngFor="let status of data.conceptStatuses; trackBy: trackByIndex" [value]="status.statusMerchantConceptId">
                  {{ status.name }}
                </mat-option>
              </mat-select>
              <mat-hint>Estado que tendrán todos los conceptos al crearlos</mat-hint>
            </mat-form-field>
          </div>

          <div class="col-md-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Personal asignado</mat-label>
              <mat-select formControlName="staffUids" multiple>
                <mat-option *ngFor="let staff of data.availableStaff; trackBy: trackByIndex" [value]="staff.id">
                  {{ staff.display }}
                </mat-option>
              </mat-select>
              <mat-hint>El personal seleccionado se asignará a todos los conceptos creados</mat-hint>
            </mat-form-field>
          </div>
        </div>
      </form>
    </div>

    <div class="creation-progress" *ngIf="isCreating">
      <div class="text-center py-4">
        <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
        <h6>Creando conceptos...</h6>
        <p class="text-muted">Por favor espera mientras se crean los {{ createTotal }} conceptos</p>
      </div>
    </div>

    <div class="creation-results" *ngIf="creationResults.length > 0">
      <h6 class="section-title mb-3">
        <mat-icon>{{ createFailureCount === 0 ? 'check_circle' : 'warning' }}</mat-icon>
        Resultados
      </h6>

      <div class="results-summary mb-3">
        <div class="summary-card success" *ngIf="createSuccessCount > 0">
          <mat-icon>check_circle</mat-icon>
          <div>
            <strong>{{ createSuccessCount }}</strong> creado{{ createSuccessCount !== 1 ? 's' : '' }} correctamente
          </div>
        </div>
        <div class="summary-card error" *ngIf="createFailureCount > 0">
          <mat-icon>error</mat-icon>
          <div>
            <strong>{{ createFailureCount }}</strong> error{{ createFailureCount !== 1 ? 'es' : '' }}
          </div>
        </div>
      </div>

      <div class="error-details" *ngIf="createFailureCount > 0">
        <h6 class="text-danger">Conceptos con errores:</h6>
        <ul>
          <li *ngFor="let result of creationResults; trackBy: trackByIndex" class="error-item" [class.d-none]="result.success">
            <strong>{{ result.conceptName }}</strong>: {{ result.error }}
          </li>
        </ul>
      </div>
    </div>

  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <ng-container *ngIf="!isCreating && creationResults.length === 0">
      <app-button
        label="Cancelar"
        icon="close"
        variant="secondary"
        (click)="onCancel()">
      </app-button>
      <app-button 
        [label]="'Añadir ' + selectedConceptIds.length + ' concepto' + (selectedConceptIds.length !== 1 ? 's' : '')"
        icon="add" 
        variant="primary" 
        [disabled]="selectedConceptIds.length === 0 || defaultsForm.invalid"
        (click)="onAdd()">
      </app-button>
    </ng-container>

    <ng-container *ngIf="isCreating">
      <app-button
        label="Cancelando no disponible"
        icon="block"
        variant="secondary"
        [disabled]="true">
      </app-button>
    </ng-container>

    <ng-container *ngIf="creationResults.length > 0">
      <app-button 
        [label]="createFailureCount === 0 ? 'Cerrar' : 'Reintentar errores'"
        variant="primary"
        [icon]="createFailureCount === 0 ? 'check' : 'refresh'"
        (click)="createFailureCount === 0 ? dialogRef.close(true) : onRetry()">
      </app-button>
    </ng-container>
  </mat-dialog-actions>

</div>
